import _ from 'lodash'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import isBrowser from 'utils/isBrowser'
import * as motorActions from 'external/reduxBits/motor/actions'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'
import { adData, motorAdData, globalData } from 'tracking/dataCollectors'

import { sliderValues } from './sliderValues'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    ...gtm.clearDataLayerParameters(),
    ...globalData(state),
    ...{
      event: 'view', // trigger GTM tags
      eventType: 'View', // Begin with uppercase. Type of action for pulse.
      objectType: 'Page', // Begin with uppercase
      domain: 'motor', // Technical domain. Ex. Adout
      subDomain: 'finance', // Technical sub domain. Ex. list.
    },
    ...adData(_.get(state, 'classified.requestedAd.ad', {})),
    ...localData,
  })

const financeValues = (state, input) => ({
  motorFinanceCompanyId: _.get(input, 'financeData.companyName'),
  motorFinanceExternalId: _.get(input, 'externalId'),
  motorFinancePrice: _.get(input, 'price.value'),
  motorFinanceRate: _.get(input, 'financeData.rate', 0) / 100,
  motorFinanceSetupFee: _.get(input, 'financeData.startFee'),
  motorFinanceMonthlyFee: _.get(input, 'financeData.monthlyFee'),
  motorFinanceMinCash: _.get(input, 'minCash'),
  motorFinanceMaxCash: _.get(input, 'maxCash'),
  motorFinanceMinMonths: _.get(input, 'financeData.minMonths'),
  motorFinanceMaxMonths: _.get(input, 'financeData.maxMonths'),
  motorFinanceMinResidualValue: 0,
  motorFinanceMaxResidualValue:
    (_.get(input, 'maxSalvageValue', 0) / 100) * _.get(input, 'price.value', 0),
  ...sliderValues(state, input),
})

export const financePageShowed = {
  validators: [
    validators.redux(
      '@@router/LOCATION_CHANGE',
      (action) => _.get(action, 'payload.location.pathname', '').endsWith('/finans') && isBrowser(),
    ),
    validators.redux(motorActions.SAVE_WIDGET_SETTINGS, () => true, ({ payload }) => payload),
  ],
  events: [
    gtm.event(({ state, accumulator }) => {
      return createDataLayerObject(state, {
        objectId: 'motor_finance_widget',
        objectName: 'Motor finance widget',
        objectCustom: {
          ...motorAdData(_.get(state, 'classified.requestedAd.ad', {})),
          ...financeValues(state, accumulator),
        },
        origin: {
          id: `motor_finance_widget`,
          type: 'Page',
          url: encodeURI(window.location.href),
        },
      })
    }),
  ],
}
